import "bootstrap/dist/css/bootstrap.css";
import { startApp } from "./Startup";

startApp();
